import PropTypes from "prop-types";
import React from "react";
import { InputGroup } from "react-bootstrap";

function FormInput(props) {
  const { children, hasOverride, inputButton, isRequired } = props;

  // If it is required, then it can never be removed.
  if (isRequired) {
    return children;
  }

  // If it has an override, then it can never be removed at this level.
  if (hasOverride) {
    return children;
  }

  return (
    <InputGroup>
      {children}
      <InputGroup.Append>
        {inputButton}
      </InputGroup.Append>
    </InputGroup>
  );
}

FormInput.propTypes = {
  children: PropTypes.node,
  hasOverride: PropTypes.bool,
  inputButton: PropTypes.element,
  isRequired: PropTypes.bool,
};

export { FormInput };
